"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemLabel = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/no-danger -- should be ok ;) */

const defaultType = new Set(['back-in-stock', 'free-sample', 'last-chance', 'loyalty', 'new', 'until-stock-lasts', 'value-set']);
const offerType = new Set(['catalogue-offer']);
const infoType = new Set(['claim', 'replacement', 'reserved-product']);
const visibility = new Set(['replacement']);
const croppedClassName = fullClassLabel => fullClassLabel.split(' ')[1];
const ItemLabel = ({
  label,
  labelClass,
  tooltip,
  testId
}) => {
  if (!label || !labelClass) {
    return null;
  }
  const croppedClass = croppedClassName(labelClass);
  const isVisible = !visibility.has(croppedClass);
  const type = defaultType.has(croppedClass) ? 'default' : infoType.has(croppedClass) ? 'info' : offerType.has(croppedClass) ? 'offer' : 'default';
  if (!isVisible) {
    return null;
  }
  if (tooltip) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
      arrow: true,
      placement: "top-start",
      title: tooltip ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        dangerouslySetInnerHTML: {
          __html: tooltip
        }
      }) : '',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
        "data-testid": testId,
        color: type,
        variant: "tag",
        label: label
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Chip, {
    "data-testid": testId,
    color: type,
    variant: "tag",
    label: label
  });
};
exports.ItemLabel = ItemLabel;
